import { createEvoClient, createOrUpdateMarketingCommunication, deleteMarketingCommunication } from "@jti/evo-client";
import type { SnpApiContact, SnpSubscribeRequest, SnpSubscribeResponse } from "@jti/rest-api-types";

import { getUser } from "../../../utils";

export class SnpApiEvo implements SnpApiContact {
  private readonly client;
  readonly name = "SnpApi";
  constructor(baseUrl: string, tenantToken: string, recaptchaId: string) {
    const { ciam_token } = getUser();
    this.client = createEvoClient({
      baseUrl,
      tenantToken,
      recaptchaId,
      throwOnError: true,
      ciamToken: ciam_token,
    });
  }

  async subscribe(subscriptionData: SnpSubscribeRequest, preferredLanguage?: string): Promise<SnpSubscribeResponse> {
    const { consent_purposes, email, preferredLanguage: preferredLanguageFromForm } = subscriptionData;
    const { data } = await createOrUpdateMarketingCommunication({
      client: this.client,
      body: {
        email,
        category: "marketing",
        consents: consent_purposes,
        preferredLanguage: preferredLanguage ?? preferredLanguageFromForm,
      },
    });

    const { uuid = "", category = "" } = data || {};
    return { languageUpdated: false, topics: [category], uuid };
  }

  async unsubscribe(subscriptionUuid: string, topics: string[]): Promise<SnpSubscribeResponse> {
    await deleteMarketingCommunication({
      client: this.client,
      path: {
        identifier: subscriptionUuid,
      },
      query: {
        "categories[]": topics,
      },
    });

    return { languageUpdated: false, topics, uuid: subscriptionUuid };
  }
}
